import type { UpgradesPackage } from '../../reducers/packages/packages'
import type { JobPostingDefinition } from '../../reducers'

import listsAreEqual from '../../../util/lists-are-equal/listsAreEqual'
import { WebshopPackage } from '../../../schema/webshop-package'

export const isUpgrade = (suggestible: WebshopPackage): boolean =>
  !{}.hasOwnProperty.call(suggestible, 'jobPosting')

export const isJobPosting = (suggestible: WebshopPackage): boolean => !isUpgrade(suggestible)

export const isBooster = (suggestible?: WebshopPackage): boolean => {
  const features = (suggestible?.upgrades || []).reduce((acc, curr) => [...new Set([...acc, ...curr.features])], [])
  return features.includes('booster')
}

export const requiredSitesMatches = (definition: JobPostingDefinition) => (
  suggestible: UpgradesPackage,
): boolean => {
  const requiredSites = suggestible.upgrades.reduce((acc, curr) => [...new Set([...acc, ...curr.requiredSites])], [])

  return listsAreEqual(requiredSites, definition.publishOn)
}

export const requiredFeaturesMatches = (definition: JobPostingDefinition) => (
  suggestible: UpgradesPackage,
): boolean => {
  const requiredFeatures = suggestible.upgrades.reduce(
    (acc, curr) => [...new Set([...acc, ...curr.requiredFeatures])],
    [],
  )

  return listsAreEqual(requiredFeatures, definition.features)
}
